/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />
/// <reference path="ilodashmixins.d.ts" />

((() => {
	'use strict';

	_.mixin({
		'htmlWhitespace': (value: string, includeSpaces: boolean = false) =>
			(includeSpaces ? value.replace(/ /g, '&nbsp;') : value)
				.replace(/\t/g, _.repeat('&nbsp;', 4))
				.replace(/\r\n|\n\r|\r|\n/g, '<br />')
	});

})());